import Swal from "sweetalert2";
import i18n from "../locales/i18n";

function createdHandler() {
  return Swal.fire(i18n.t("saved"), "", "success");
}

export default createdHandler;
